export default "__VITE_ASSET__DGESbEAb__"